import appStyles from '../styles.css?inline';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.tsx';

const style = document.createElement('style');
style.textContent = appStyles;
document.head.append(style);

const rootEl = document.getElementById('root');
if (rootEl === null) {
  document.body.textContent = 'power-admin: #root not found';
} else {
  createRoot(rootEl).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
